import { css } from 'aphrodite';
import * as React from 'react';
import { useState, useEffect } from 'react';
import { PhoneNumberLabelCombobox } from '../PhoneNumberLabelCombobox';
import { TextInput } from '../../TextInput';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	label?: string;
	onLabelChanged?(label: string): void;
	onValueChanged?(value: string): void;
	inputClassName?: string;
	rootElementType?: 'none' | 'div';
	value?: string;
}

export const EditEntityInfoPhoneNumber: React.FC<IProps> = ({
	className,
	label: labelProp,
	onLabelChanged,
	onValueChanged,
	inputClassName,
	rootElementType = 'div',
	value: valueProp,
}) => {
	const [label, setLabel] = useState(labelProp || '');
	const [value, setValue] = useState(valueProp || '');

	// Sync with props when they change
	useEffect(() => {
		setLabel(labelProp || '');
	}, [labelProp]);

	useEffect(() => {
		setValue(valueProp || '');
	}, [valueProp]);

	const handleLabelChange = (newLabel: string) => {
		if (onLabelChanged) {
			onLabelChanged(newLabel);
		} else {
			setLabel(newLabel);
		}
	};

	const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newValue = e.target.value;
		if (onValueChanged) {
			onValueChanged(newValue);
		} else {
			setValue(newValue);
		}
	};

	const content = (
		<>
			<PhoneNumberLabelCombobox
				label={label}
				onLabelChange={handleLabelChange}
				styles={[styleSheet.phoneNumberSelectBox]}
			/>
			<TextInput
				autoComplete='off'
				className={`${css(styleSheet.bulletListItemTextField)} ${inputClassName || ''}`}
				inputId='edit-entity-phone-number-input'
				onChange={handleValueChange}
				type='text'
				value={value || ''}
			/>
		</>
	);

	if (rootElementType && rootElementType !== 'none') {
		return React.createElement(
			rootElementType,
			{ className: `${css(styleSheet.container)} edit-entity-info-phone-number ${className || ''}` },
			content
		);
	}
	return content;
};
